
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M78.1 64L126 16.1c1.3-1.3 2-3.1 2-4.9 0-1.9-.7-3.6-2-5L121.8 2c-1.3-1.3-3.1-2-5-2s-3.6.7-4.9 2L64 49.9 16.1 2c-1.3-1.3-3.1-2-5-2-1.8 0-3.5.7-4.9 2L2 6.2c-2.7 2.7-2.7 7.2 0 9.9L49.9 64 2 111.9c-1.3 1.3-2 3.1-2 5s.7 3.6 2 5l4.2 4.2c1.3 1.3 3.1 2 4.9 2 1.9 0 3.6-.7 5-2l47.9-48 47.9 47.9c1.3 1.3 3.1 2 4.9 2 1.9 0 3.6-.7 5-2l4.2-4.2c1.3-1.3 2-3.1 2-5s-.7-3.6-2-5L78.1 64z"}})])
          )
        }
      }
    